export enum Roles {
  Internal = 'Internal',
  Administrator = 'Administrator',
  IssueReviewer = 'IssueReviewer',
}
